import Text from '@/shared-components/text/components/Text';

import "./AgreementContent.css";

export default function ArtworkAgreement() {
 
  return (
    <>
      <div className="artwork-terms__content">

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          By submitting an artwork to Suarte, the Gallery agrees to the following terms and conditions:
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">1. Ownership of Artwork</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery warrants and represents that it is the legal owner of the artwork and has the right to enter into this agreement, granting Suarte the right to display and offer the artwork for sale.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">2. Intellectual Property Rights</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery acknowledges that the artist retains all intellectual property rights, even after the artwork is sold. The Gallery pledges to only present artworks to Suarte for which it has secured rights from the legitimate owners and shall bear responsibility for any claims or damages resulting from any breach of this assurance. In such an event, the Gallery will defend, indemnify, and hold harmless Suarte.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">3. Selling in-store</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Galleries are welcome to sell artworks both online and in their physical spaces.
        </Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          After the purchase, if the collector wants to claim their artwork on the platform, Galleries must immediately mark the artwork as sold on the platform and provide the collector's email address for proper recording of the transaction and proper management of artwork claims on the platform.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">4. Withdraw Artworks Responsibility</Text>

        <Text className="artwork-agreement__text font-size-medium" paragraph justify>
          At Suarte, Galleries have the flexibility to withdraw artworks at any moment for free, recognizing situations where sales happen outside our platform's direct influence.
        </Text>
        <Text className="artwork-agreement__text font-size-medium" paragraph justify>
          However, when collectors express interest in artworks discovered on Suarte, we advocate for a partnership-driven approach. We request that such sales be finalized through Suarte to honor the role of the company’s promotional efforts and investment.
        </Text>
        <Text className="artwork-agreement__text font-size-medium" paragraph justify>
          Galleries can also mark the artwork as sold on their profile while maintaining a 0% Suarte's commission. The new collector will also be added to the Gallery’s contact list.
        </Text>
        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Galleries agree to comply with Suarte’s Withdraw Artworks Responsibility.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">5. Limited Editions</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          In the case of activating limited editions, the Gallery agrees and acknowledges that it will not produce, manufacture, or distribute any further prints or limited editions of the artwork without the express written consent of Suarte.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">6. Pricing</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery retains complete autonomy in setting the price of the artwork and must offer the "Buy Now" feature for all artworks uploaded to the platform. While the Gallery may adjust pricing over time, maintaining consistency is essential, as stable pricing reinforces trust and preserves the perceived value of the work.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">7. Price modifications</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          To ensure fairness across the market, the artwork must not be offered at a lower price outside Suarte. The platform continuously monitors pricing alignment, and inconsistencies may result in restrictions or the removal of the Gallery's profile on Suarte.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">8. Payment and Invoices</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Payments from Suarte to Galleries for original artworks are processed after the 24-hour cancellation policy has ended, minus Suarte’s commission, which scales from 17% down to 5% based on the Gallery’s sales volume for originals, excluding taxes and shipping costs.
        </Text>
        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Invoices: Suarte includes the reduced (or, until January 1, 2027, waived) commission for in-store sales and the referral system in the monthly invoice, accessible through the Gallery's profile menu. Limited Editions commissions become available in the Gallery's Stripe balance 14 days after delivery. If the balance is negative, Galleries must credit the amount within 15 days of receiving the invoice.
        </Text>
        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Payments and refunds will be credited to the account provided by the Gallery in the ‘’bank account’’ section inside the platform. The Gallery agrees to keep this information updated, and Suarte is not responsible if a payment is made to an outdated account.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">9. Shipping</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery is responsible for shipping the artwork to the buyer and must provide tracking information within 7 days (168 hours) of confirmation. During the uploading process, the Gallery may choose to assume the shipping costs or charge the customer for them.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">10. Returns and Refunds</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Sellers are responsible for addressing and resolving issues related to: lost or damaged items, products not as described, quality issues, or receiving fake goods. Galleries should coordinate with the collector for return shipping arrangements and provide refunds.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">11. Legal Compliance</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery agrees to comply with all the rules and laws related to selling and shipping artwork. This includes things like export and import regulations, copyright laws, and tax laws.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">12. Authenticity</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery guarantees the authenticity of the artwork and that it is an original creation by the artist.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">13. Artwork Condition</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery is responsible for ensuring that the artwork is in the same condition as described on the platform and free from any defects not mentioned in the description.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">14. Artist's rights protection</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery agrees that artists' interests and rights are protected throughout the selling process and beyond.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">15. Confidentiality</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Both parties agree to maintain the confidentiality of any sensitive information shared during the course of the agreement in compliance with GDPR regulations.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">16. Promotional Use of Artwork</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The Gallery acknowledges and agrees that Suarte may promote and advertise the artwork and use the photographs of the artwork for advertising purposes without the need for additional consent or compensation.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">17. Responsibilities</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Each party is responsible for fulfilling its obligations under this agreement. In the event of a breach, the offending party will be liable for any damages incurred.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">18. Early termination</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          The agreement may be prematurely terminated due to non-compliance, among other reasons, which will be determined on a case-by-case basis.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">19. Dispute Resolution</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          In the event of a dispute arising from or in connection with this agreement, the parties agree to first attempt to resolve the dispute amicably through negotiation. If the dispute cannot be resolved through negotiation, the parties agree to submit the dispute to the exclusive jurisdiction of the Spanish courts.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">20. Termination</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          Suarte reserves the right to terminate this agreement at any time.
        </Text>

        <Text className="artwork-agreement__subheading font-size-large">21. Specific Events</Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          For specific events, this contract does apply unless otherwise agreed in writing between the parties.
        </Text>

        <Text
          className="artwork-agreement__text margin font-size-medium"
          paragraph
          justify>
          By checking the box provided during the artwork uploading process, the Gallery agrees to these terms and conditions and acknowledges that this commitment is binding and enforceable under applicable laws and regulations. Once accepted, these terms remain valid for any future modifications to the artwork without requiring additional confirmation.
        </Text>
      </div>
    </>
  );
}
